export const plural = (n, one, many) => `${Number(n ?? 0).toLocaleString()} ${n === 1 ? one : many}`;
export const listed = (items) =>
  items.length < 2 ? items.join("") : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;

// What one item is made from, by the kind of project the data is in.
export const UNITS = {
  collect: [
    { value: "record", label: "Each record" },
    { value: "photo", label: "Each photo" },
  ],
  annotate: [{ value: "task", label: "Each task" }],
};
const RECORD_TAGS = ["<ImageRecord", "<AudioRecord", "<VideoRecord"];
export const kindOf = (project) =>
  RECORD_TAGS.some((tag) => (project?.label_config ?? "").includes(tag)) ? "collect" : "annotate";

const IMAGE = /\.(jpe?g|png|gif|webp|bmp|svg)(\?.*)?$/i;
const first = (value) => (Array.isArray(value) ? value[0] : value);

export const cellText = (value) => {
  if (Array.isArray(value)) return value.length === 1 ? String(value[0]) : plural(value.length, "item", "items");
  if (value && typeof value === "object") return "…";
  return String(value ?? "");
};

/** A table cell for one field of an item: a thumbnail for a picture, text otherwise. */
export const Cell = ({ value }) => {
  const one = first(value);
  if (typeof one === "string" && IMAGE.test(one) && /^(\/|https?:)/.test(one)) {
    return (
      <span className="lsf-dataset__thumb">
        <img src={one} alt="" loading="lazy" />
        {Array.isArray(value) && value.length > 1 ? <em>+{value.length - 1}</em> : null}
      </span>
    );
  }
  return <span>{cellText(value)}</span>;
};

/** Why a request failed, in the server's words when it gave any. */
export const why = (res, fallback) => {
  const body = res?.response ?? {};
  const errors = body.validation_errors;
  const flat = Array.isArray(errors)
    ? errors
    : errors && typeof errors === "object"
      ? Object.values(errors).flat()
      : [];
  const said = flat.find((e) => typeof e === "string") ?? (typeof errors === "string" ? errors : null);
  return said ?? (body.detail && body.detail !== "Validation error" ? body.detail : fallback);
};

export const SampleTable = ({ fields, rows, action }) => (
  <div className="lsf-dataset__scroll">
    <table className="lsf-dataset__table">
      <thead>
        <tr>
          {fields.map((f) => (
            <th key={f}>{f}</th>
          ))}
          {action ? <th aria-label="Actions" /> : null}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={row.id ?? i}>
            {fields.map((f) => (
              <td key={f} title={cellText((row.data ?? row)[f])}>
                <Cell value={(row.data ?? row)[f]} />
              </td>
            ))}
            {action ? <td className="lsf-dataset__row-action">{action(row)}</td> : null}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
